import { render, staticRenderFns } from "./RenderComponent.vue?vue&type=template&id=3afa2647&scoped=true&"
import script from "./RenderComponent.vue?vue&type=script&lang=js&"
export * from "./RenderComponent.vue?vue&type=script&lang=js&"
import style0 from "./RenderComponent.vue?vue&type=style&index=0&id=3afa2647&lang=scss&scoped=true&"
import style1 from "./RenderComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa2647",
  null
  
)

export default component.exports